<template>
  <div class="roadmap-counter">
    <span class="roadmap-counter_in-progress">Выполнение: {{ nodeData.in_progress_count }}, </span>
    <span class="roadmap-counter_done">Выполнено: {{ nodeData.done_count }}, </span>
    <span class="roadmap-counter_expired">Не выполнено: {{ nodeData.expired_count }}, </span>
    <span class="roadmap-counter_needs-work">Требуется доработка: {{ nodeData.needs_work_count }}</span>
  </div>
</template>

<script>


export default {
  name: 'LKRoadmapsFeedTitleStatuses',
  props: {
    nodeData: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.roadmap-counter {
  &_in-progress {
    color: $webflow-color-blue-dark;
  }

  &_done {
    color: $webflow-color-green;
  }

  &_needs-work {
    color: $webflow-color-pink;
  }

  &_expired {
    color: $webflow-color-red;
  }
}

</style>
